/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Confirmation } from '../../models/confirmation';

export interface PostApiPublicAppointmentConfirmation$Params {

/**
 * The appointment uuid
 */
  uuid: string;
  '_locale': 'de' | 'en' | 'fr';
      body: Confirmation
}

export function postApiPublicAppointmentConfirmation(http: HttpClient, rootUrl: string, params: PostApiPublicAppointmentConfirmation$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, postApiPublicAppointmentConfirmation.PATH, 'post');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.path('_locale', params['_locale'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

postApiPublicAppointmentConfirmation.PATH = '/api/public/{_locale}/appointment/{uuid}/confirmation';
